/* eslint-disable max-len */
import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import alert from 'react-s-alert';
import { ModalContext } from 'App';
import * as action from '../action';
import * as c from '../constant';

function ChangePasswordModal({
  profile,
  setFormData,
  formData,
  getUserManagementList,
  showUserManagement,
  updateAdminPassword,
  history,
  getRoleList,
  updating,
}) {
  const setModal = useContext(ModalContext);

  const validateForm = useFormValidator(formData, {
    password: 'required|password',
    re_password: 'required|password',
  });

  const OnSetFormData = () => {
    setFormData({
      password: profile.attributes.password || '',
      re_password: '',
    });
  };
  
  const handleOnSubmit = (e) => {
    e.preventDefault();
    const pass = _.get(formData, 'password');
    const rePass = _.get(formData, 're_password');
    if (pass === rePass) {
      updateAdminPassword(profile.id, formData, ({ data }) => {
        getUserManagementList();
        setModal({ isOpen: false });
        showUserManagement(profile.id);
        history.push(`/user-management/employees/${_.get(data, 'id')}`);
      });
    } else {
      alert.error('Password does not match');
    }
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      OnSetFormData();
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      OnSetFormData();
    }
  }, [profile]);

  useEffect(() => {
    getRoleList();
  }, []);

  useEffect(() => {
    validateForm.validate();
  }, [
    Object.keys(formData).join(','),
    Object.values(formData).join(','),
  ]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="form-label">
              Password: {validateForm.renderMessage('password')}
            </label>
            <input
              className="form-control"
              type="password"
              name="password"
              placeHolder="Password"
              value={_.get(formData, 'password')}
              onChange={onChange}
              autoComplete="new-password"
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Re-type Password: {validateForm.renderMessage('re_password')}
            </label>
            <input
              className="form-control"
              type="password"
              name="re_password"
              placeHolder="Password"
              value={_.get(formData, 're_password')}
              onChange={onChange}
              autoComplete="new-password"
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating || !validateForm.response.is_passed || formData.password !== formData.re_password}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

ChangePasswordModal.propTypes = {
  profile: PropTypes.instanceOf(Object).isRequired,
  updateAdminPassword: PropTypes.instanceOf(Function).isRequired,
  getUserManagementList: PropTypes.instanceOf(Function).isRequired,
  showUserManagement: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  getRoleList: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  profile: _.get(api, `${c.GET_SINGLE_USER_MANAGEMENT}.item`) || {},
  roleList: _.get(api, `${c.GET_ROLE_LIST}.list`) || [],
  updating: api.loading.indexOf(c.UPDATE_USER_MANAGEMENT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(ChangePasswordModal);
